@import 'apps/webcomponents/src/assets/fonts.scss';

:host {
  display: block;
  max-width: 560px;
  padding: calc(3 * var(--spacer)) 0 calc(3 * var(--spacer)) calc(5 * var(--spacer));
  color: var(--main-titles-inputs-600);
}

.title-container {
  height: calc(4 * var(--spacer));
  display: flex;
  align-items: center;
}

.subtitle {
  color: var(--chart-300-icon-buttons);
}

.title {
  color: var(--main-titles-inputs-600);
}

gz-text {
  color: var(--body-text-arrows-400);
}

.feedback-field {
  &.general {
    --form-field-label-width: 160px;
  }
}

.text-uppercase {
  text-transform: uppercase;
}

gz-radio {
  height: calc(4 * var(--spacer));
  margin-bottom: var(--spacer);
  display: flex;
}

.feedback-form-wrapper {
  gz-text {
    padding: var(--spacer) 0;
  }
}

.link-prefix {
  width: fit-content;
  margin-right: 2px;
}

.d-flex {
    display: flex;
}
